import React from "react";
import {Helmet} from 'react-helmet'
function PageHelmet(props){
    const title = props.pageTitle === 'Osobní stránka'
        ? 'Tomáš Zikmunda | Reality a developerské projekty'
        : `${props.pageTitle} | Tomáš Zikmunda`;
        return(
            <React.Fragment>
                <Helmet>
                    <title>{title}</title>
                    <meta name="description" content={props.metaDescription} />
                    <meta name="keywords" content={props.metaKeywords} />
                    <meta property="og:image" content={props.ogImage} />
                </Helmet>
            </React.Fragment>
        )
}


export default PageHelmet;
